<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-12"
      :itemList="itemList"
      :canAddCategory="canAddCategory"
      @on-delete-category="onDeleteCategory"
      @on-attach-permission="onAttachPermission"
    ></list-table>
  </div>
</template>

<script>
import ListTable from "../components/pref-category-edits/list-table.vue";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import Api from "@/logic/api/api.js";
import valueMapper from "../logic/common/value-mapper";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },
  computed: {
    itemList() {
      return this.$store.getters.managePrefCategoryList;
    },
  },
  data() {
    this.$nextTick(() => {
      this.reloadData();
    });
    return {
      errors: [],
      canAddCategory: false,
    };
  },
  methods: {
    /**
     * 分類を一覧で取得する
     */
    reloadData() {
      this.$store.commit("setWaiting", true);

      const apiRequests = [];
      const processList = [];

      // 分類を取得する
      apiRequests.push("category.list");
      processList.push(
        Api.call("/admin/hiroshima/information/category", {})
      );

      Promise.all(processList)
        .then((result) => {
          this.$store.commit("setWaiting", false);
          //APIから取得した結果を画面に表示する
          let categoryList = [];
          if (apiRequests.includes("category.list")) {
            categoryList = result[apiRequests.indexOf("category.list")].categorys;
            console.log("categoryList = ");
            console.log(JSON.stringify(categoryList));
            console.log("result[apiRequests.indexOf(category.list)].category_list");
            console.log(result[apiRequests.indexOf("category.list")]);
          }

          this.$store.commit(
              "setManagePrefCategoryList",
              categoryList.map((category) => {
                return {
                  recordId: category.record_id,
                  category: category.category,
                  order: category.order,
                  usedNumber: category.used_number,
                  categoryEdit: {
                    editable: true,
                  },
              };
            })
            .sort((a, b) => a.order - b.order) // 昇順でソート
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * 分類を削除する
     */
    onDeleteCategory(selected) {
      const deletedMap = {};
      console.log("selected[0] = ");
      console.log(selected[0]);
      console.log("selected[0].recordId = ");
      console.log(selected[0].recordId);
      // 送信パラメータを作成する
      const postData = {
        record_id: selected[0].recordId
      };
      console.log("postData = ");
      console.log(postData);
      this.clearMessage();
      this.$nextTick(() => {
        // 分類を削除する
        this.$store.commit("setWaiting", true);
        Api.call("/admin/hiroshima/information/category/delete", postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                success: AlertBuilder.success("削除しました"),
                failed: AlertBuilder.error("削除に失敗しました"),
              })
              .get(result.message);
            if (message) {
              this.errors.push(message);
            }
            if (result.failed) {
              result.failed.forEach((info) => {
                this.errors.push(
                  AlertBuilder.error(
                    `[${deletedMap[info.uid]}]:${info.reason.jp}`
                  )
                );
              });
            }
            this.reloadData();
          })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            Api.resolve(result);
          });
      });
    },
  },
};
</script>

<style></style>
